// How each platform looks and behaves in the AI Studio and the post composer.
export const PLATFORMS = {
  linkedin: { label: "LinkedIn", color: "#0a66c2", limit: 3000, glyph: "in" },
  facebook: { label: "Facebook", color: "#1877f2", limit: 63206, glyph: "f" },
  instagram: { label: "Instagram", color: "#e1306c", limit: 2200, glyph: "ig" },
  tiktok: { label: "TikTok", color: "#25f4ee", limit: 2200, glyph: "tt" },
  youtube: { label: "YouTube", color: "#ff0000", limit: 5000, glyph: "yt" },
  pinterest: { label: "Pinterest", color: "#e60023", limit: 800, glyph: "p" },
};
export const platformLabel = (k) => PLATFORMS[k]?.label || k;

export const GOAL_LABELS = { awareness: "Get noticed", offer: "Promote an offer", leads: "Get enquiries", education: "Teach", trust: "Build trust" };
export const TONE_LABELS = {
  friendly: "Friendly", professional: "Professional", bold: "Bold", playful: "Playful",
  inspirational: "Inspiring", educational: "Helpful", luxury: "Premium", urgent: "Urgent",
};
export const REWRITE_LABELS = {
  shorter: "Shorter", longer: "Longer", punchier: "Punchier", friendlier: "Friendlier", professional: "More formal",
  emoji: "Add emoji", no_emoji: "Remove emoji", hashtags: "Add hashtags", cta: "Add call to action", grammar: "Fix grammar",
};
export const LANGUAGES = ["Same as my material", "English", "Hindi", "Tamil", "Telugu", "Malayalam", "Kannada", "Bengali", "Marathi",
  "Gujarati", "Spanish", "French", "German", "Portuguese", "Arabic", "Indonesian", "Filipino", "Chinese", "Japanese"];
